import ConnectedProducersListHeader from './ConnectedProducersListHeader'
export default ConnectedProducersListHeader
